/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { PatientReferredTo } from 'app/shared/model/enumerations/patient-referred-to.model';
import { createEntity, getEntity, reset, updateEntity } from './intra-op-recovery.reducer';

export const IntraOPRecoveryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const intraOPRecoveryEntity = useAppSelector(state => state.intraOPRecovery.entity);
  const loading = useAppSelector(state => state.intraOPRecovery.loading);
  const updating = useAppSelector(state => state.intraOPRecovery.updating);
  const updateSuccess = useAppSelector(state => state.intraOPRecovery.updateSuccess);
  const patientReferredToValues = Object.keys(PatientReferredTo);

  const handleClose = () => {
    navigate(`/intra-op-recovery${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getNurses({}));
    dispatch(getVitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...intraOPRecoveryEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      surgeon: doctors.find(it => it.id.toString() === values.surgeon?.toString()),
      scrubNurse: nurses.find(it => it.id.toString() === values.scrubNurse?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientReferredTo: 'RECOVERY',
          ...intraOPRecoveryEntity,
          surgery: intraOPRecoveryEntity?.surgery?.id,
          surgeon: intraOPRecoveryEntity?.surgeon?.id,
          scrubNurse: intraOPRecoveryEntity?.scrubNurse?.id,
          vitals: intraOPRecoveryEntity?.vitals?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.intraOPRecovery.home.createOrEditLabel" data-cy="IntraOPRecoveryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.intraOPRecovery.home.createOrEditLabel">Create or edit a IntraOPRecovery</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="intra-op-recovery-id"
                  label={translate('tinyMedicRestApp.intraOPRecovery.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.levelOfRecovery')}
                id="intra-op-recovery-levelOfRecovery"
                name="levelOfRecovery"
                data-cy="levelOfRecovery"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.coherence')}
                id="intra-op-recovery-coherence"
                name="coherence"
                data-cy="coherence"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.reflexes')}
                id="intra-op-recovery-reflexes"
                name="reflexes"
                data-cy="reflexes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.headLift')}
                id="intra-op-recovery-headLift"
                name="headLift"
                data-cy="headLift"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.saeaSenosoryLevel')}
                id="intra-op-recovery-saeaSenosoryLevel"
                name="saeaSenosoryLevel"
                data-cy="saeaSenosoryLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.saeaMotorLevel')}
                id="intra-op-recovery-saeaMotorLevel"
                name="saeaMotorLevel"
                data-cy="saeaMotorLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.patientReferredTo')}
                id="intra-op-recovery-patientReferredTo"
                name="patientReferredTo"
                data-cy="patientReferredTo"
                type="select"
              >
                {patientReferredToValues.map(patientReferredTo => (
                  <option value={patientReferredTo} key={patientReferredTo}>
                    {translate(`tinyMedicRestApp.PatientReferredTo.${patientReferredTo}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.active')}
                id="intra-op-recovery-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.cursor')}
                id="intra-op-recovery-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.lastupdated')}
                id="intra-op-recovery-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.microSec')}
                id="intra-op-recovery-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPRecovery.timestampentry')}
                id="intra-op-recovery-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="intra-op-recovery-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.intraOPRecovery.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-recovery-surgeon"
                name="surgeon"
                data-cy="surgeon"
                label={translate('tinyMedicRestApp.intraOPRecovery.surgeon')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-recovery-scrubNurse"
                name="scrubNurse"
                data-cy="scrubNurse"
                label={translate('tinyMedicRestApp.intraOPRecovery.scrubNurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="intra-op-recovery-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.intraOPRecovery.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/intra-op-recovery" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntraOPRecoveryUpdate;
